@if (alertService.currentDialog) {
  <div>
    <div  id="OKCancelOptionDialog" style="top: 330px;">
      <div class="window-bar" id="ok-cancel-window-bar" >
        <label>{{alertService.currentDialog.title}}</label>
        <button type="button" id="btnClose" (click)="closeDialog()">X</button>
      </div>
      <div id="customDialogOKCancel" class="enterTorn">
        <label id="dialogMessage">{{alertService.currentDialog.Message}}</label>
        @if (alertService.currentDialog.Inputs) {
          <div>
            @for (input of alertService.currentDialog.Inputs; track input; let i = $index) {
              <div >
                <label id="Input{{i}}" for="output{{i}}">{{input}}</label>
                <input id="output{{i}}" [(ngModel)]="alertService.currentDialog.InputResponses[i]"/>
              </div>
            }
          </div>
        }
        @if (alertService.currentDialog.Buttons == 'OKCancel' || alertService.currentDialog.Buttons == 'OK') {
          <div class="ButtonStrip">
            <button type="button" id="btnOK" (click)="OK(alertService.currentDialog)">OK</button>
            @if (alertService.showCancelButton == true) {
              <button type="button" id="btnCancel" (click)="alertService.currentDialog = null">Cancel</button>
            }
          </div>
        }
        @if (alertService.currentDialog.Buttons == 'YesNo') {
          <div class="ButtonStrip">
            <button type="button" id="btnYES" (click)="YES(alertService.currentDialog)">YES</button>
            <button type="button" id="btnNO" (click)="NO(alertService.currentDialog)">NO</button>
          </div>
        }
      </div>
    </div>
    <!-- <div id="changeDateModal" *ngIf="alertService.showChangeTornDates == true">
    <div class="window-bar" id="edit-torn-window-bar">
      <label>Edit Torn</label>
      <button type="button" id="btnCloseChangeTorn" (click)="closeDialog()">X</button>
    </div>
    <div id="customDialogChangeTornDates" class="newTorn">
      <div id="EditTorn" >
        <div><label for="txtName2s">Name of Torn:  </label><input id="txtName2s" [(ngModel)]="DataService.SelectedTorn.name" /></div>
        <div>
          <label for="StartDate" >Start Date:  </label><input id="StartDate" matInput [matDatepicker]="picker1" [(ngModel)]="DataService.SelectedTorn.dateOfEvent">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle><mat-datepicker #picker1 ></mat-datepicker>
        </div>
        <div>
          <label for="FinishDate">Finish Date:  </label>
          <input id="FinishDate" matInput [matDatepicker]="picker2" [(ngModel)]="DataService.SelectedTorn.endDateOfEvent">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2 ></mat-datepicker>
        </div>
        <div>
          <label for="ClosingDate">Closing Date:  </label>
          <input id="ClosingDate" matInput [matDatepicker]="picker3" [(ngModel)]="DataService.SelectedTorn.closingDate">
          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          <mat-datepicker #picker3 ></mat-datepicker>
        </div>
        <div>
          <label for="DirectorList2">Director:  </label>
          <select *ngIf="DataService.LoggedInUser.accessLevel > 1" id="DirectorList2" name="DirectorList2" [(ngModel)]="DataService.SelectedTorn.directorId" style="display:block">
            <option *ngFor="let player of DataService.Directors" [ngValue]="player.id">{{player.name}}</option>
          </select>
        </div>
        <label style="font-weight: 700; font-size: 26px;    display: contents;">Info:</label><br />
        <div><label for="VenueInfo">Venues:</label><textarea id="VenueInfo" name="VenueInfo" [(ngModel)]="DataService.SelectedTorn.venueInfo"></textarea></div><br /><br />
        <div><label for="AccomodationInfo">Accomodation:</label><textarea id="AccomodationInfo" name="AccomodationInfo" [(ngModel)]="DataService.SelectedTorn.accomodationInfo"></textarea></div><br /><br />
        <div><label for="ScheduleInfo">Schedules:</label><textarea id="ScheduleInfo" name="ScheduleInfo" [(ngModel)]="DataService.SelectedTorn.scheduleInfo"></textarea></div><br /><br />
        <div><label for="PrizeGivingInfo">Prize Giving:</label><textarea id="PrizeGivingInfo" name="PrizeGivingInfo" [(ngModel)]="DataService.SelectedTorn.prizeGivingInfo"></textarea></div><br /><br />
        <div><label for="ExtraInfo">Extra:</label><textarea id="ExtraInfo" name="ExtraInfo" [(ngModel)]="DataService.SelectedTorn.extraInfo"></textarea></div><br /><br />
        <div><label for="AccNumber">Account Number:</label><input id="AccNumber" name="AccNumber" [(ngModel)]="DataService.SelectedTorn.account"/></div><br /><br />
        <div><label for="AccName">Account Name:</label><input id="AccName" name="AccName" [(ngModel)]="DataService.SelectedTorn.accountName"/></div><br /><br />
        <div>
          <div style="display:grid">
            <div>
              <label>Preset Infosheet: </label>
              <input *ngIf="!DataService.SelectedTorn.presetInfoSheet" type="file" (change)="uploadFile($event)" name="presetInfoSheet" placeholder="upload file" accept=".doc, .docx, .txt"/>
              <label (click)="DataService.SelectedTorn.presetInfoSheet = null">{{DataService.SelectedTorn.presetInfoSheet}}</label>
            </div>
            <div>
              <label>Poster: </label>
              <input *ngIf="!DataService.SelectedTorn.posterLocation" type="file" (change)="uploadFile($event)" name="posterLocation" placeholder="upload file" accept=".jpg, .png, .jpeg"/>
              <img *ngIf="DataService.SelectedTorn.posterLocation" src="assets/{{DataService.SelectedTorn.posterLocation}}" (click)="DataService.SelectedTorn.posterLocation = null" width="30" height="40" style="display:block" />
            </div>
            <div>
              <label>Sponsor: </label>
              <input *ngIf="!DataService.SelectedTorn.sponsorImage" type="file" (change)="uploadFile($event)" name="sponsorImage" placeholder="upload file" accept=".jpg, .png, .jpeg"/>
              <img *ngIf="DataService.SelectedTorn.sponsorImage"  src="assets/{{DataService.SelectedTorn.sponsorImage}}" (click)="DataService.SelectedTorn.sponsorImage = null" width="100" height="40" style="display:block;position: relative;    margin-bottom: 10px;"/>
            </div>
            <div *ngIf="DataService.SelectedTorn.sponsorImage"><label>Sponsor URL:</label><input style=" max-width: 700px; width: auto;min-width: 100px" id="txtSponsorURL" name="txtSponsorURL" [(ngModel)]="DataService.SelectedTorn.sponsorURL" /></div>
            <div><label>Live Stream URL:</label><input style=" max-width: 700px; width: 400px;" id="txtLiveStreamURL" name="txtLiveStreamURL" [(ngModel)]="DataService.SelectedTorn.liveStreamURL" /></div>
          </div>
        </div>
      </div>
      <button type="button" id="btnUpdateTorn" style="margin-bottom: 10px;display:inline" (click)="saveTorn(DataService.SelectedTorn)" class="newTorn">OK</button>
    </div>
  </div> -->
  <!-- <div id="newTornModal" *ngIf="alertService.showCreateNewTorn == true">
  <div class="window-bar" id="new-torn-window-bar">
    <label>New Torn</label>
    <button type="button" id="btnCloseNewTorn" (click)="closeDialog()">X</button>
  </div>
  <div id="customDialogTorn" style="margin: 5px">
    <div><label>Name of Torn:  </label><input id="NewTornName" [(ngModel)]="DataService.newTorn.name" /></div>
    <div><label for="DirectorList2">Director:  </label><select id="DirectorList" name="DirectorList" [(ngModel)]="DataService.newTorn.directorId">
    <option *ngFor="let player of DataService.Directors" [ngValue]="player.id">{{player.name}}</option>
  </select></div>
  <div><label>Courts:  </label><input type="number" id="NewTornCourts" [(ngModel)]="DataService.newTorn.Courts" title="Minimum courts of all sports"/></div>
  <button type="button" id="btnCreateNewTorn" (click)="CreateNewTorn(DataService.newTorn)">Create New Torn</button>
</div>
</div> -->
@if (alertService.showAnnouncementDialog == true) {
  <div id="AnnouncementDialog" style="top: 200px;left: 130px">
    <!-- <div class="window-bar" id="Announcement-window-bar">
      <label>Email Announcement</label>
      <button type="button" id="btnCloseAnnouncementDialog" name="btnCloseAnnouncementDialog" (click)="closeDialog()">X</button>
    </div> -->
    <div id="customAnnouncementText" class="enterTorn">
      <div><textarea style="height: 200px;width: 800px;margin-top: 10px" id="txtAnnouncementText" [(ngModel)]="Announcement"></textarea></div>
      @for (entry of DataService.SelectedTorn.entries; track entry; let i = $index) {
        @if (entry.email != '') {
          <div style="width: fit-content;">
            <input type="checkbox" id="chkEntry{{i}}"  [(ngModel)]="entry.SendAnnouncement" /><label id="lblentryPlayerName{{i}}">{{entry.name}}</label>
          </div>
        }
      }
      <label style="width: 451px;">You will need to contact the following players using Facebook or Mobile as they have no email details:</label>
      @for (entry of DataService.SelectedTorn.entries; track entry; let i = $index) {
        @if (entry.email == '') {
          <div class="width: fit-content;">
            <input type="checkbox" id="lblEntry{{i}}"  /><label id="lblentryPlayerName{{i}}">{{entry.name}}</label>
          </div>
        }
      }
      <button type="button" id="btnChangeAnnouncementText" (click)="ConfirmAnnouncement()" class="enterTorn" style="margin: 10px">OK</button>
    </div>
  </div>
}
<!-- <div id="newDrawModal" *ngIf="alertService.showCreateNewDraw == true">
<div class="window-bar" id="new-draw-window-bar">
  <label>New Draw</label>
  <button type="button" id="btnCloseEditEntries" (click)="closeDialog()">X</button>
</div>
<div id="customDialogDraw" style="display: grid">
  <div>
    <label>Name of draw:  </label><input [(ngModel)]="DataService.newDraw.name" type="text" autocomplete="nope" id="txtName" />
  </div>
  <div id="DrawFormat">
    <label for="rdoKO">Knockout</label><input type="radio" id="KODraw" name="rdoFormat" value="KO" [(ngModel)]="DataService.newDraw.format"/>
    <label for="rdoRR">Round Robin</label><input type="radio" id="RRDraw" name="rdoFormat" value="RR" [(ngModel)]="DataService.newDraw.format" />
    <label for="rdoPO">Playoffs</label><input type="radio" id="PODraw" name="rdoFormat" value="PO" [(ngModel)]="DataService.newDraw.format" />
  </div>
  <div id="DrawGender">
    <label for="rdoKO">Male</label><input type="radio" id="MaleGender" name="rdoGender" value="M" [(ngModel)]="DataService.newDraw.gender" />
    <label for="rdoRR">Female</label><input type="radio" id="FemaleGender" name="rdoGender" value="F" [(ngModel)]="DataService.newDraw.gender" />
    <label for="rdoPO">Unisex</label><input type="radio" id="UnisexGender" name="rdoGender" value="U" [(ngModel)]="DataService.newDraw.gender" />
  </div>
  <div *ngFor="let event of DataService.SelectedTorn.events">
    <label for="EventSelect{{event.id}}">
      <input type="radio" id="EventSelect{{event.id}}" name="EventSelect" [(ngModel)]="DataService.newDraw.theEventID" [value]="event.id" />{{event.name}} - {{event.type}} - ({{event.Total}})
    </label>
  </div>
  <input type="button" id="btnCreateNewDraw" [disabled]="!DataService.newDraw.format || !DataService.newDraw.gender || !DataService.newDraw.name || DataService.newDraw.theEventID == 0" (click)="CreateNewDraw()" value="Create New Draw"/>
</div>
</div> -->
</div>
}